import { useState, type ReactNode } from "react"
import { ChevronDown, ChevronUp, SlidersHorizontal, X } from "lucide-react"
import { Badge } from "@/components/ui/badge"

interface FilterPanelProps {
  activeCount: number
  onClear: () => void
  children: ReactNode
}

export function FilterPanel({ activeCount, onClear, children }: FilterPanelProps) {
  const [isOpen, setIsOpen] = useState(activeCount > 0)

  return (
    <div>
      {/* Toggle button */}
      <div className="flex items-center gap-2">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="inline-flex h-8 items-center gap-1.5 rounded-md border border-input px-2.5 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted"
        >
          <SlidersHorizontal size={14} />
          Filtry
          {activeCount > 0 && (
            <Badge
              variant="default"
              className="ml-0.5 h-4 min-w-4 px-1 text-[10px] leading-none"
            >
              {activeCount}
            </Badge>
          )}
          {isOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </button>
        {activeCount > 0 && (
          <button
            onClick={onClear}
            className="inline-flex h-8 items-center gap-1 rounded-md px-2 text-xs text-muted-foreground transition-colors hover:bg-muted"
          >
            <X size={12} />
            Wyczysc filtry
          </button>
        )}
      </div>

      {/* Panel content */}
      {isOpen && (
        <div
          className="mt-2 rounded-lg border border-border bg-card p-4"
        >
          <div className="grid grid-cols-1 gap-x-4 gap-y-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {children}
          </div>
        </div>
      )}
    </div>
  )
}
